import { render, staticRenderFns } from "./TaskSidebarLink.vue?vue&type=template&id=722f8a28&"
import script from "./TaskSidebarLink.vue?vue&type=script&lang=js&"
export * from "./TaskSidebarLink.vue?vue&type=script&lang=js&"
import style0 from "./TaskSidebarLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports